module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAkklEQVRYR+2XUQqAIBBE3ZPVzaqb1ckmNgxCtA3WWoLxR9DQ52sslRRcJHj+1AUAwFxbiIhU26/P9gSYCoiFADRwGsghHYqMbNr/SQgzQDWk/wCw9vndClW724BnAgLQwCMDAMbG32y1BvD2H9+BN1NujU8AGqABGqABAYDI65kCWNcnBdRX1apd/F0OpR6CcIAdpDyJqS/bsOEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/reportForm.png
// module id = lxHk
// module chunks = 1